var map = {
	"./1.jpg": 9806,
	"./2.1.jpg": 3251,
	"./3.jpg": 438,
	"./4'.jpg": 1422,
	"./5.jpg": 7982,
	"./6.1.jpg": 3056,
	"./8.jpg": 4010,
	"./9.jpg": 7811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3959;